import React, { MouseEvent, KeyboardEvent } from 'react';
import { withTracking } from '../../utils/tracking/tracking';

interface IIconButtonProps {
	['data-cy']?: string;
	children?: React.ReactNode;
	className?: string;
	ariaLabel?: string;
	style?: React.CSSProperties;
	title?: string;
	onClick?: (ev: MouseEvent<HTMLElement> | KeyboardEvent<HTMLElement>) => void;
	onAnimationEnd?: () => void;
}

export const IconButtonComponent = ({
	title = '',
	className = '',
	ariaLabel,
	children,
	'data-cy': dataCy = 'button',
	style = {},
	onClick,
	onAnimationEnd,
}: IIconButtonProps) => {
	return (
		<button
			data-cy={dataCy}
			className={`cursor-pointer bg-transparent ${className}`}
			style={style}
			title={title}
			aria-label={ariaLabel || title}
			onClick={onClick}
			onKeyDown={(e) => {
				if ((e.key === 'Enter' || e.key === ' ') && onClick) {
					e.preventDefault();
					onClick(e);
				}
			}}
			onAnimationEnd={onAnimationEnd}>
			{children}
		</button>
	);
};

export const IconButton = withTracking(IconButtonComponent);
